annualPlanPercentSavingsFromPlanData